<template>
  <div class="meteorologicalMonitoring-container">
    <el-form
      size="medium"
      inline
      :model="queryForm"
      ref="queryForm"
      class="input-form-inline"
      @submit.native.prevent
    >
      <el-form-item class="r-20" prop="plate">
        <el-input
          v-model.trim="queryForm.plate"
          placeholder="请输入车牌号"
          @keyup.enter.native="query"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="query">查询</el-button>
        <el-button @click="reset">取消</el-button>
      </el-form-item>
      <!-- <div style="margin-bottom:20px">
        <el-button type="primary" @click="addData">新增</el-button>
      </div> -->
    </el-form>
    <el-table
      ref="multipleTable"
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%"
      size="mini"
      stripe
      height="560px"
    >
      <el-table-column width="20"></el-table-column>
      <el-table-column type="index" label="序号" width="55"></el-table-column>
      <el-table-column
        prop="plate"
        label="车牌号"
        min-width="120"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="deviceId"
        label="设备编号"
        min-width="120"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="datetime"
        label="数据更新时间"
        min-width="120"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="雨量"
        label="雨量"
        min-width="100"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="超声波风速"
        label="超声波风速"
        min-width="100"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="校正风向"
        label="校正风向"
        min-width="100"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="风向"
        label="风向"
        min-width="100"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="电子罗盘"
        label="电子罗盘"
        min-width="100"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="雨量累计"
        label="雨量累计"
        min-width="100"
        show-overflow-tooltip
      ></el-table-column>
      <!-- <el-table-column label="操作" min-width="180" fixed="right">
        <template slot-scope="{ row }">
          <div class="options">
            <el-button
              type="text"
              @click="closeStatus(row, 2)"
              v-if="row.timeSwitch == 1"
              >关闭</el-button
            >
            <el-button
              type="text"
              @click="closeStatus(row, 1)"
              v-else-if="row.timeSwitch == 2"
              >开启</el-button
            >
            <el-button type="text" @click="editorData(row)">修改</el-button>
            <el-button type="text" @click="delData(row)">删除</el-button>
            <el-button type="text" @click="checkHistory(row)"
              >历史数据</el-button
            >
          </div>
        </template>
      </el-table-column> -->
    </el-table>
    <el-pagination
      @current-change="handleCurrentChange"
      :current-page.sync="currentPage"
      :page-size="limit"
      layout="total, prev, pager, next, jumper"
      :total="total"
    ></el-pagination>
    <!-- 新增/编辑 -->
    <el-dialog :title="addOrEditorTitle" :visible.sync="dialogVisible">
      <el-form
        :rules="dialogRules"
        ref="dialogFormRef"
        :model="dialogForm"
        size="mini"
        label-width="100px"
      >
        <el-form-item label="工单名称" prop="name">
          <el-input
            v-model="dialogForm.name"
            placeholder="请输入工单名称"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addFlag = false">取 消</el-button>
        <el-button type="primary" @click="saveOrUpdate">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "MeteorologicalMonitoring",
  data() {
    return {
      queryForm: {
        name: "",
        plate: "",
      },
      tableData: [],
      addOrEditorTitle: "",
      dialogVisible: false,
      editFlag: false,
      dialogRules: {
        name: [{ required: true, trigger: "change", message: "请输入名称" }],
      },
      dialogForm: {
        name: "",
      },
      currentPage: 1,
      limit: 10,
      total: 0,
      timer: null,
    };
  },
  created() {
    this.query();
    this.timer = setInterval(() => {
      this.query();
    }, 60000);
  },
  methods: {
    query() {
      this.getMeteorologicalMonitoringList();
    },
    reset() {
      this.$resetForm(this, "queryForm");
    },
    addData() {
      // 清楚表单数据
      this.$resetForm(this, "queryForm");
      // 修改弹框标题
      this.addOrEditorTitle = "新增";
      // 状态重置为新增状态
      this.editFlag = false;
      // 打开弹框
      this.dialogVisible = true;
    },
    editorData() {
      // 清楚表单数据
      this.$resetForm(this, "queryForm");
      // 修改弹框标题
      this.addOrEditorTitle = "修改";
      // 状态重置为编辑状态
      this.editFlag = true;
      // 打开弹框
      this.dialogVisible = true;
    },
    // 确认提交表单
    saveOrUpdate() {
      this.$refs.dialogFormRef.validate((valid) => {
        if (valid) {
          // 新增
        }
      });
    },
    //页数改变时触发
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getMeteorologicalMonitoringList();
    },
    async getMeteorologicalMonitoringList() {
      let obj = {
        page: this.currentPage,
        limit: this.limit,
        plate: this.queryForm.plate,
      };
      let { data: res } = await this.$axios.get("/api/weather/list", {
        params: obj,
      });
      if (res.code == 1) {
        this.tableData = this.handleWaterTestInfo(res.data.list);
        this.total = res.data.totalCount;
      } else {
        this.$message.warning(res.msg);
      }
    },
    handleWaterTestInfo(list) {
      let waterTestInfo = [];
      let newList = [];
      let datetime = "";
      waterTestInfo = list.map((item) => {
        newList = item.entity.map((ele) => {
          datetime = ele.datetime;
          return {
            [ele.eName]: `${ele.eValue}${ele.eUnit}`,
          };
        });
        let mergedSensors = Object.assign({}, ...newList);
        return { ...item, ...mergedSensors, datetime };
      });
      return waterTestInfo;
    },
  },
  beforeDestroy() {
    // 清除定时器
    clearInterval(this.timer);
  },
};
</script>
<style lang="scss" scoped>
.meteorologicalMonitoring-container {
  height: calc(100% - 40px);
  background-color: #fff;
  margin: 20px;
  padding: 0 20px;
  /deep/ .el-dialog {
    .el-form-item__content {
      width: 420px;
    }
    .dialog-footer {
      .el-button + .el-button {
        margin-left: 20px;
      }
    }
  }
}
</style>
